import { getContact } from 'core/domain/Load'
import { getFormattedRate, getFormattedRatePerMile } from 'core/presenters/loadPresenter'
import { ShipperInformation } from 'core/ui/components/shipper/ShipperInformation'

import { type Load } from '../domain/Load'
import { LoadDeadline } from './LoadDeadline'
import {
  Body,
  ContentWrapper,
  DeadlineWrapper,
  ShipperInfoWrapper,
  Wrapper,
} from './LoadHeader.styles'
import { LoadRate } from './LoadRate'
import { TenderConfirmation } from './TenderConfirmation'

export type LoadHeaderProps = {
  load: Load
  onAccept?: (load: Load) => void
  onReject?: (load: Load) => void
}

export function LoadHeader({ load, onAccept, onReject }: LoadHeaderProps) {
  const { shipper, type } = load
  const shipperContact = getContact(load)

  return (
    <Wrapper>
      <DeadlineWrapper>
        <LoadDeadline load={load} />
      </DeadlineWrapper>
      <Body>
        <ContentWrapper>
          <ShipperInfoWrapper>
            {shipper && (
              <ShipperInformation
                companyName={shipper?.companyName}
                logo={shipper?.logoUrl}
                showContactInfo
                email={shipperContact.email}
                phone={shipperContact.phone}
                contactName={shipperContact.name}
                data-testid="load-header-shipper-information"
              />
            )}
          </ShipperInfoWrapper>
          <LoadRate
            rate={getFormattedRate(load)}
            ratePerMile={getFormattedRatePerMile(load)}
            providerRateId={load.providerRateId}
            data-testid="load-header-load-rate"
          />
          {type === 'tender' && (
            <TenderConfirmation load={load} onAccept={onAccept} onReject={onReject} />
          )}
        </ContentWrapper>
      </Body>
    </Wrapper>
  )
}
